import React, { useEffect, useRef, useState, useContext } from 'react';
import { Button, Modal, OverlayTrigger, Tooltip } from 'react-bootstrap';
import './clientProfile.scss';
import { UserProfileContext } from '../../context/userProfileContext';
import { useLocation, useNavigate } from 'react-router-dom';
import EditClient from '../clients/EditClient';
import Tasks from './Tasks';
import Comments from '../../components/Comments';
import { useQuery } from '../../hooks';
import Loader from '../../components/Loader';
import { ApiError } from '../../utils/api/ApiError';
import OffCanvasWrapper from '../../components/offCanvas/OffCanvasWrapper';
import { activateNextModule, editClient, editOnboarding, getClient, getClientsModules } from '../../utils/api/clients';
import { editPension } from '../../utils/api/pension';
import { editTaxReturn } from '../../utils/api/taxReturn';
import { Client } from '../../interfaces/Client';
import Onboarding from './onboarding/Onboarding';
import Pension from './pension/Pension';
import TaxReturn from './taxReturn/TaxReturn';
import Modules from '../../utils/modules';
import { getTaskCount } from '../../utils/api/tasks';
import { User } from '../../interfaces/User';
import { getUsers } from '../../utils/api/users';
import Mortgage from './mortgage/Mortgage';
import { editMortgage } from '../../utils/api/mortgage';
import { editInsurance } from '../../utils/api/insurance';
import { editLoan } from '../../utils/api/loan';
import { editDeposit } from '../../utils/api/deposit';
import Loan from './loan/Loan';
import Deposit from './deposits/Deposit';
import Insurance from './insurance/InsurancePage';
import { editBankFees } from '../../utils/api/bankFees';
import BankFees from './bankFees/BankFees';
import Investment from './investments/Investment';
import { editInvestment } from '../../utils/api/investment';
import { set } from 'date-fns';
import useComments from '../../hooks/useComments';
import globalErrorHandler from '../../utils/globalErrorHandler';
import Drawers from '../../components/Drowers';
import { editPcInsurance } from '../../utils/api/pcInsurance';
import PCInsurance from './pcInsurance/PCInsurance';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { camelCaseToText } from '../../utils/camelCaseToText';
import { formatDate } from '../../utils/formatDate';
import CreateSpouse from './clientInfo/CreateSpouse';
import { useTranslation } from 'react-i18next';
import { RatingLevel } from '../../interfaces/Client';
import EditClientFamilyMemebrsButton from '../../components/family-members-editing/EditClientFamilyMemebrsButton';
import { Link } from 'react-router-dom';
import useEmployerEdit from '../employers/hooks/useEmployerEdit';
import { addCommas } from '../../utils/addCommas';
import ordinal from '../../utils/oridnalSuffix';
import { APICore } from '../../utils/api/apiCore';
import { Tooltip as MuiTooltip } from '@mui/material';
import Files from '../files';
import ModuleTabs from './moduleTabs/ModuleTabs';
import ClientInfo from './clientInfo/ClientInfo';
import CreateRoundReasonModal from '../../components/CreateRoundReasonModal';

const maxCharsInAText = 20;

const modulesThatAreNotDraggable = ['onboardings', 'pensions'];

const Profile = () => {
    const query = useQuery();
    const navigate = useNavigate();
    const mounted = useRef(false);
    const { t } = useTranslation('utils');

    const [client, setClient] = useState<Client>();
    const [isLoading, setIsLoading] = useState(false);
    const [modules, setModules] = useState<any>({});
    const [openTasksCount, setOpenTasksCount] = useState<number>(0);
    const [showAddClient, setShowAddClient] = useState<boolean>(false);
    const [users, setUsers] = useState<User[]>([]);
    const [allUsers, setAllUsers] = useState<User[]>([]);
    const [showCreateRoundReasonModal, setShowCreateRoundReasonModal] = useState<boolean>(false);

    const [pendingRoundCreation, setPendingRoundCreation] = useState<{
        clientId: string;
        module: string;
        apiCall?: (reason: string) => Promise<any>;
    } | null>(null);

    const [profileContextData, setProfileContextData] = useState<any>({
        selectedModule: undefined,
        currentRound: undefined,
        client: undefined,
        setClient: setClient,
        optionalModules: [],
        modules: {},
        expandClientData: false,
        isManager: false,
    });

    const [isRoundBeingCreated, setIsRoundBeingCreated] = useState(false);

    useEffect(() => {
        if (client && modules && Object.keys(modules).length > 0) {
            const contextData = { ...profileContextData };

            if (contextData.selectedModule) {
                const { moduleName } = contextData.selectedModule.data;
                for (const key in modules) {
                    if (modules[key].data.moduleName === moduleName) {
                        contextData.selectedModule = modules[key];
                    }
                }
            } else {
                const moduleName = query.get('module') || 'onboarding';
                for (const key in modules) {
                    if (modules[key].data.moduleName === moduleName) {
                        contextData.selectedModule = modules[key];
                        break;
                    }
                }
                if (!contextData.selectedModule) contextData.selectedModule = modules.onboardings;
            }

            if (!contextData.currentRound && contextData.selectedModule && contextData.selectedModule.data.permittedToView) {
                contextData.currentRound = contextData.selectedModule.data.rounds[0];
            }

            contextData.modules = modules;
            contextData.client = client;
            contextData.setClient = setClient;

            setProfileContextData(contextData);
        }
    }, [client, modules]);

    // useEffect(() => {
    //     if (profileContextData.selectedModule) {
    //         setProfileContextData( ( prev: any ) => ({
    //             ...prev,
    //             // isSelectedActive: profileContextData?.selectedModule?.serverName === client?.currentModule + "s",
    //             // allowedStatusesOptions: modules[client?.currentModule + "s"]?.allowedStatuses ?  Object.values(modules[client?.currentModule + "s"]?.allowedStatuses) : [],
    //         }))
    //     }
    // }, [profileContextData.selectedModule, client])

    const onEditRound = async (body: any, module: string, roundId: string, onSuccess?: () => void, onError?: () => void) => {
        const prevData = JSON.parse(JSON.stringify(profileContextData));
        const contextData = { ...profileContextData };
        const round = contextData.selectedModule.data.rounds.find((r: any) => r._id === roundId);

        for (const key in body) {
            // contextData.currentRound[key] = body[key];
            round[key] = body[key];
        }

        setProfileContextData(contextData);
        let response;

        try {
            if (module === Modules.onboarding) {
                response = await editOnboarding(roundId, body);
                await handleModules();
            } else if (module === Modules.pension) {
                response = await editPension(roundId, body);
            } else if (module === Modules.taxReturn) {
                response = await editTaxReturn(roundId, body);
            } else if (module === Modules.mortgage) {
                response = await editMortgage(roundId, body);
                // } else if (module === Modules.deposit) {
                //     response = await editDeposit(roundId, body);
                // } else if (module === Modules.loans) {
                // response = await editLoan(roundId, body);
            } else if (module === Modules.insurance) {
                response = await editInsurance(roundId, body);
            } else if (module === Modules.pcInsurance) {
                response = await editPcInsurance(roundId, body);
            } else if (module === Modules.bankFees) {
                response = await editBankFees(roundId, body);
            } else if (module === Modules.investment) {
                response = await editInvestment(roundId, body);
            }

            const newCurrentRound = response[module];
            const newContextData = { ...profileContextData };
            for (const key in newCurrentRound) {
                newContextData.currentRound[key] = newCurrentRound[key];
            }
            setProfileContextData(newContextData);
            if (onSuccess) {
                onSuccess();
            }
        } catch (err: any) {
            if (onError) onError();

            setProfileContextData(prevData);
            if (err.errorCode === 'POWER_OF_ATTORNEY_OUTDATED') {
                window.alert('Power of attorney out of date');
            } else if (err.errorCode === 'MISSING_ID_ATTACHMENT') {
                if (err.extraData?.fileId) {
                    const result = window.confirm('ID attachment is not classified, or contains errors');
                    if (result) {
                        const url = `/clients/profile/files?clientId=${client?._id}&fileId=${err.extraData.fileId}`;
                        navigate(url);
                    }
                } else {
                    window.alert('ID attachment is not classified, or contains errors');
                }
            } else if (err.status === 402) {
                window.alert('Please set signing probability');
            } else if (err.status === 405) {
                window.alert("The status you are trying to set is not allowed, client didn't sign forms");
            } else if (err.status === 410) {
                window.alert('Please generate signing forms');
            } else if (err.status === 411) {
                window.alert('The following files are still missing: ' + err.extraData.join(', '));
            } else if (err.status === 412) {
                window.alert('Please generate the signing documents first');
            } else if (err.status === 413) {
                window.alert('Id number is either empty or invalid - make sure to set the right one');
            } else if (err.status === 414) {
                window.alert('Status cannot change before all Jotforms are submitted');
                window.location.reload();
            } else if (err.status === 415) {
                window.alert(`We don't have the client's Israeli ID. Please get a copy of the ID and classify it`);
            } else {
                globalErrorHandler(err);
            }
        }
    };

    const onCreateNewRound = async (clientId: string, module: string, createApiCall?: (reason: string) => Promise<any>, creationReason?: string) => {
        // All modules require reason selection
        if (!creationReason) {
            setPendingRoundCreation({ clientId, module, apiCall: createApiCall });
            setShowCreateRoundReasonModal(true);
            return;
        }

        setIsRoundBeingCreated(true);
        try {
            if (createApiCall) {
                await createApiCall(creationReason);
            } else {
                return;
            }

            await handleModules();
        } catch (err: any) {
            if (createApiCall) {
                // If custom API call, let it handle its own specific errors if needed.
                // If the error is marked as handled, skip globalErrorHandler.
                if (!err.isHandled) {
                    globalErrorHandler(err);
                }
                return;
            }

            globalErrorHandler(err);
        } finally {
            setIsRoundBeingCreated(false);
        }
    };

    const handleCreateRoundWithReason = async (reason: string) => {
        if (pendingRoundCreation) {
            setShowCreateRoundReasonModal(true); // Keep modal open
            await onCreateNewRound(pendingRoundCreation.clientId, pendingRoundCreation.module, pendingRoundCreation.apiCall, reason);
            setPendingRoundCreation(null);
            setShowCreateRoundReasonModal(false); // Close modal after creation completes
        }
    };

    const onCloseAddClientModal = () => setShowAddClient(false);

    const onEditClient = () => {
        setShowAddClient(true);
    };

    const getData = async () => {
        const clientId = query.get('clientId');
        if (!clientId) {
            navigate('/clients');
            return;
        }

        const result: PromiseSettledResult<any>[] = await Promise.allSettled([
            getClient(clientId),
            getClientsModules(clientId),
            getTaskCount({ clientId }),
            getUsers({ status: 'all', limit: 1000 }),
        ]);

        // check if result[0] was fullfilled

        if (result[0].status === 'fulfilled') {
            setClient(result[0].value.client);
        } else {
            globalErrorHandler(result[0].reason);
        }

        if (result[1].status === 'fulfilled') {
            setModules(arrangeModules(result[1].value.modules));
        }

        if (result[2].status === 'fulfilled') {
            setOpenTasksCount(result[2].value.count);
        }

        if (result[3].status === 'fulfilled') {
            setUsers(result[3].value.users.filter((user: User) => user.isActive));
            setAllUsers(result[3].value.users);
        }

        setIsLoading(false);
    };

    const handleModules = async () => {
        try {
            const clientId = query.get('clientId');
            if (!clientId) {
                navigate('/clients');
                return;
            }

            const result = await getClientsModules(clientId);

            setModules(arrangeModules(result.modules));
        } catch (err: any) {
            globalErrorHandler(err);
        } finally {
            setIsLoading(false);
        }
    };

    const arrangeModules = (modules: any) => {
        for (const key in modules) {
            modules[key].data = {
                moduleName: Object.values(Modules).find((module) => key.includes(module)),
                rounds: modules[key][key] || [],
                allowedStatuses: modules[key].allowedStatuses,
                permittedToEdit: modules[key].permittedToEdit,
                permittedToView: modules[key].permittedToView,
            };
            // modules[key].data.rounds.forEach((round: any, i: number) => round.round = i+1);
        }
        return modules;
    };

    useEffect(() => {
        mounted.current = true;
        if (mounted) {
            setIsLoading(true);
            getData();
        }

        return () => {
            mounted.current = false;
        };
    }, []);

    useEffect(() => {
        if (client && client.fullName) {
            document.title = client.fullName;
        }

        return () => {
            document.title = 'Better Admin';
        };
    }, [client]);

    const onEditClientForm = async (newClient: Client, oldClient?: Client) => {
        try {
            if (oldClient) {
                await editClient(oldClient._id, newClient);
                setClient(newClient);
            }
            onCloseAddClientModal();
        } catch (err) {
            globalErrorHandler(err);
        }
    };

    const isFilesPage = () => {
        return window.location.pathname.includes('files');
    };

    const getContent = () => {
        if (isFilesPage()) return <Files />;

        const moduleName = profileContextData?.selectedModule?.data?.moduleName;
        if (!moduleName) return;

        if (moduleName === Modules.onboarding) return <Onboarding />;
        else if (moduleName === Modules.pension) return <Pension />;
        else if (moduleName === Modules.taxReturn) return <TaxReturn />;
        else if (moduleName === Modules.mortgage) return <Mortgage />;
        // else if (moduleName === Modules.loans) return <Loan />;
        // else if (moduleName === Modules.deposit) return <Deposit />;
        else if (moduleName === Modules.insurance) return <Insurance />;
        else if (moduleName === Modules.pcInsurance) return <PCInsurance />;
        else if (moduleName === Modules.bankFees) return <BankFees />;
        else if (moduleName === Modules.investment) return <Investment />;
    };

    const getUserById = (userId: string | undefined): User | undefined => {
        if (!userId) return undefined;
        return allUsers.find((user: User) => user._id === userId);
    };

    return (
        <UserProfileContext.Provider
            value={{
                profileContextData,
                users,
                allUsers,
                getUserById,
                setProfileContextData,
                onCreateNewRound,
                onEditClient,
                onEditRound,
                isRoundBeingCreated,
            }}
        >
            {/*<UserProfileContext.Provider value={{}}>*/}
            <div className="profile-wrapper">
                <div className="regular-modules">
                    <ClientInfo />
                    <ModuleTabs />
                    <Drawers client={client} selectedModule={profileContextData?.selectedModule?.data?.moduleName} openTasksCount={openTasksCount} />

                    {isLoading && <Loader />}

                    <div className={profileContextData?.selectedModule?.data?.moduleName}>{getContent()}</div>
                </div>
            </div>
            {client && <EditClient show={showAddClient} onHide={onCloseAddClientModal} onAddClient={onEditClientForm} client={client} />}
            <CreateRoundReasonModal
                show={showCreateRoundReasonModal}
                onHide={() => {
                    setShowCreateRoundReasonModal(false);
                    setPendingRoundCreation(null);
                }}
                onConfirm={handleCreateRoundWithReason}
                moduleName={pendingRoundCreation?.module ? t(pendingRoundCreation.module) : ''}
                isLoading={isRoundBeingCreated}
            />
        </UserProfileContext.Provider>
    );
};

export default Profile;
